<template>
  <CustomPage title="账户安全">
    <div slot="content" class="content">
      <div
        class="cell van-hairline--bottom"
        v-for="item in menu"
        :key="item.label"
        @click="cellClick(item.router)"
      >
        <div class="label">
          <span>{{ item.label }}</span>
        </div>
        <div class="value">
          <span class="value-val">{{ item.value }}</span>
          <img :src="require('@/assets/setting/箭头.svg')" alt="" />
        </div>
      </div>
      <div class="cell van-hairline--bottom">
        <div class="label">
          <span>手机绑定</span>
        </div>
        <div class="value">
          <span class="value-val">{{ userInfoMobile }}</span>
          <!-- <img :src="require('@/assets/setting/箭头.svg')" alt="" /> -->
        </div>
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import { mapState } from 'vuex'
import CustomPage from '@/components/custom-page.vue'
import CustomView from '@/components/custom-view.vue'
export default {
  components: { CustomPage, CustomView },
  data() {
    return {
      menu: [
        { label: '登陆密码', router: 'SettingSafePwd' },
        { label: '支付密码', router: 'SettingSafePayPwd' },
      ],
    }
  },
  computed: {
    ...mapState({
      userInfoMobile: (state) => state.user.userInfoMobile,
    }),
  },
  methods: {
    cellClick(name) {
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  padding: 22px 24px;
}
.cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  padding: 24px 0;
  &::after {
    border-color: #f2f2f2;
  }
  img {
    display: inline-block;
  }
  .label {
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-right: 10px;
    }
  }
  .value {
    .value-val {
      margin-right: 10px;
    }
    img {
      width: 26px;
      height: 26px;
    }
  }
}
</style>